import { render, staticRenderFns } from "./articleShareLCard.vue?vue&type=template&id=9a60feb4&scoped=true"
import script from "./articleShareLCard.vue?vue&type=script&lang=ts"
export * from "./articleShareLCard.vue?vue&type=script&lang=ts"
import style0 from "./articleShareLCard.vue?vue&type=style&index=0&id=9a60feb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60feb4",
  null
  
)

export default component.exports